import { FunctionComponent, memo, useEffect } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { ISubtopicMobile } from "./ISubtopicMobile";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import TextInputFieldC from "../../Components/TextInput/TextInputFieldC";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { addSubtopicMobile } from "../../Redux/Slices/SubtopicMobile/AddSubtopicMobileSlice";
import { EditSubtopicMobile } from "../../Redux/Slices/SubtopicMobile/EditSubtopicMobileSlice";
import Select from "../../Components/Select/AutoComplete";
import { AutocompleteOption } from "../../Components/Select/ISelectProps";
import NumberInputField from "../../Components/NumberInput/NumberInputField";

interface SubtopicMobileFormProps {
  formRef: React.RefObject<HTMLFormElement>;
  initialValues: ISubtopicMobile;
  setInitialValues: React.Dispatch<React.SetStateAction<ISubtopicMobile>>;
}

const SubtopicMobileForm: FunctionComponent<SubtopicMobileFormProps> = (
  props
) => {
  const dispatch = useAppDispatch();

  const userSchema = z.object({
    id: z.number().optional(),
    name: z
      .string({ message: "Please enter sup topic" })
      .min(1, { message: "Please enter sup topic" }),
    sequence: z.number({ message: "Please enter sequence" }),
    subject: z.number({
      required_error: "Please select subject",
      invalid_type_error: "Please select subject",
    }),
    year_level_id: z.number({
      required_error: "Please select year level",
      invalid_type_error: "Please select year  level",
    }),
    status: z.boolean({
      message: "Please select the status",
    }),
  });
  const methods = useForm<ISubtopicMobile>({
    defaultValues: {
      ...props.initialValues,
      status: props.initialValues.id ? props.initialValues.status : true,
    },
    resolver: zodResolver(userSchema),
    mode: "onChange",
  });

  const onSubmit: SubmitHandler<ISubtopicMobile> = (val) => {
    if (val.id) {
      dispatch(EditSubtopicMobile(val));
    } else {
      dispatch(addSubtopicMobile(val));
    }
  };

  useEffect(() => {
    return () => {
      props.setInitialValues({});
    };
  }, [dispatch, props]);

  // Status list
  const SubtopicMobileSatus = [
    {
      label: "Active",
      value: true,
    },

    {
      label: "Inactive",
      value: false,
    },
  ];

  const { data: listSubjectMobiles } = useAppSelector(
    (state) => state.ListSubjectMobileSlice
  );
  const SUbjectList = Array.isArray(listSubjectMobiles?.data)
    ? listSubjectMobiles?.data
        ?.filter((role) => role.status !== false) // Filter out roles where status is false
        .map((listQuestions) => ({
          label: listQuestions?.name!,
          value: listQuestions.id,
        }))
    : [];

  const { data: listyear } = useAppSelector(
    (state) => state.ListyearGroupSlice
  );

  const yearlevelList = Array.isArray(listyear?.data)
    ? listyear?.data
        ?.filter((role) => role.status !== false) // Filter out roles where status is false
        .map((listyear) => ({
          label: listyear.year_group!,
          value: listyear.id,
        }))
    : [];
  return (
    <FormProvider {...methods}>
      <form
        ref={props.formRef}
        onSubmit={methods.handleSubmit(onSubmit)}
        className="form_double_input"
      >
        <TextInputFieldC name="name" label="Sub Topic" type="text" />
        <Select
          name="subject"
          label=" Select the subject"
          options={SUbjectList ?? []}
          value={
            SUbjectList?.find(
              (list) => list.value === methods.getValues("subject")
            ) ?? null
          }
          onChange={(_, value) => {
            const val = value as AutocompleteOption;
            methods.setValue("subject", val?.value, {
              shouldValidate: true,
            });
          }}
        />
        <NumberInputField name="sequence" label="Sequence" type="number" />

        <Select
          name="year_level_id"
          label="Select the year level"
          options={yearlevelList ?? []}
          value={
            yearlevelList?.find(
              (list) => list.value === methods.getValues("year_level_id")
            ) ?? null
          }
          onChange={(_, value) => {
            const val = value as AutocompleteOption;
            methods.setValue("year_level_id", val?.value, {
              shouldValidate: true,
            });
          }}
        />
        <Select
          name="status"
          label="Status"
          options={SubtopicMobileSatus}
          value={
            SubtopicMobileSatus?.find(
              (role) => role.value === methods.getValues("status")
            ) ?? null
          }
          onChange={(_, value) => {
            const val = value as AutocompleteOption;
            methods.setValue("status", val?.value, { shouldValidate: true });
          }}
        />
      </form>
    </FormProvider>
  );
};

export default memo(SubtopicMobileForm);
